import React, { useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import "../CreateCompany/CreateCompany.css";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import axios from "../../API/axios";
import { getOwnCompaniesList } from "../../Services/apiService";
import { debounce } from "lodash";
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";
import { customStyles } from "../../selectStyles";
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import ArrowBackIosNewSharpIcon from '@mui/icons-material/ArrowBackIosNewSharp';
import ReactQuill from "react-quill";
import { useTranslation } from "react-i18next";
import useEscapeKeyDown from "../../hooks/useEscapeKeyDown";
import useIndustryScopedMaster from "../../hooks/useIndustryScopedMaster";
import {
  creatableSkillSelectDefaults,
  onCreatableInputChange,
} from "../../utils/creatableSelectHelpers";
import { mapCompanyOption } from "../../utils/industryScopedMaster";
import SkillSuggestChips from "../../components/SkillSuggestChips";

const UpdateJob = ({
  showModal,
  closeModal,
  openModal,
  item,
  AllJobList,
  setJobList,
  jobList,
  totalPages,
  setTotalPages,
  page,
}) => {
  console.log('item', item);
  const { t } = useTranslation();
  useEscapeKeyDown(showModal, closeModal);
  const master = useIndustryScopedMaster({
    language: localStorage.getItem("Lang"),
    sessionId: localStorage.getItem("sessionId"),
  });

  const sessionId = localStorage.getItem("sessionId");
  const [display, setDisplay] = useState(false);

  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);
  const language = localStorage.getItem("Lang");
  const [singleJobData, setSingleJobData] = useState("");
  const [jobListData, setJobListData] = useState("");


  const cleanShortDescription = (htmlString) => {
    return htmlString
      .replace(/<h3>/gi, "<div>")
      .replace(/<\/h3>/gi, "</div>")
      .replace(/<strong>/gi, "")
      .replace(/<\/strong>/gi, "");
  };


  console.log("singleJobData", singleJobData);
  const JobList = async () => {
    try {
      await axios
        .get(`Job/GetJobDetails?DeviceType=Web&JobId=${item.jobId}&langKey=${language}`)
        .then((resData) => {
          setSingleJobData(resData.data.responseData.viewJob);
          const jobData = resData.data.responseData.viewJob;
          setJobListData(jobData);
          setjobTitle(jobData?.title);
          if (jobData?.shortDescription) {
            setjobDescription(cleanShortDescription(jobData.shortDescription));
          }
          // setjobDescription(jobData?.shortDescription); 
          setMinimumSalary(jobData?.minSalary);
          setMaximumSalary(jobData?.maxSalary);
          setCurrency(jobData?.currency);
          setHashtags(jobData?.hashTags);
          const loadedScreening =
            resData.data.responseData.screeningQuestions ||
            resData.data.responseData.ScreeningQuestions ||
            [];
          setScreeningQuestions(
            Array.isArray(loadedScreening)
              ? loadedScreening
                  .map((q) => q.question ?? q.Question ?? "")
                  .filter((q) => q !== undefined && q !== null)
              : []
          );
          setCompanyId({ value: jobData?.compUid, label: jobData?.compName });
          setCityId({ value: jobData?.cityId, label: jobData?.cityName });
          setJobTypeId({ value: jobData?.jbTypId, label: jobData?.jbTypName });
          setWorkTypeId({
            value: jobData?.workLevelType,
            label: jobData?.workLevelTypeName,
          });
          setWorkLocationId({
            value: jobData?.workLocationType,
            label: jobData?.workLocationTypeName,
          });
          setWorkLocationId({
            value: jobData?.workLocationType,
            label: jobData?.workLocationTypeName,
          });
          setValue({
            value: jobData?.designationId,
            label: jobData?.designationName,
          });
          master.hydrateFromJob(
            jobData,
            resData.data.responseData.skills || resData.data.responseData.Skills
          );
          setsalaryId({
            value: jobData?.salaryTypeId,
            label: jobData?.salaryTypeId,
          });
        });
    } catch (error) {
      console.log(error);
    }
  };
  console.log("jobListData", jobListData);

  useEffect(() => {
    JobList();
  }, []);

  const [jobTitle, setjobTitle] = useState("");
  const [jobDescription, setjobDescription] = useState("");
  const [minimumSalary, setMinimumSalary] = useState("");
  const [maximumSalary, setMaximumSalary] = useState("");
  const [currency, setCurrency] = useState("");
  const [hashtags, setHashtags] = useState("");
  const [screeningQuestions, setScreeningQuestions] = useState([]);

  //********Company List Start  ********//
  const [companyData, setCompanyData] = useState([]);

  const addScreeningQuestion = () => {
    if (screeningQuestions.length >= 5) return;
    setScreeningQuestions((prev) => [...prev, ""]);
  };

  const updateScreeningQuestion = (index, value) => {
    setScreeningQuestions((prev) =>
      prev.map((q, i) => (i === index ? value : q))
    );
  };

  const removeScreeningQuestion = (index) => {
    setScreeningQuestions((prev) => prev.filter((_, i) => i !== index));
  };

  const saveScreeningQuestions = async (jobId) => {
    if (!jobId) return;
    const questions = screeningQuestions
      .map((q) => (typeof q === "string" ? q.trim() : ""))
      .filter(Boolean)
      .map((question, i) => ({
        question,
        idealAnswer: "",
        isOptional: false,
        mustHave: false,
        sortOrder: i,
      }));
    try {
      await axios.put("/Job/SetScreeningQuestions", {
        deviceType: "Web",
        sessionId,
        langKey: language === "en" ? "" : language,
        jobId,
        questions,
      });
    } catch (e) {
      console.log("SetScreeningQuestions failed", e);
    }
  };
  const [companySearch, setCompanySearch] = useState("");
  const [companyId, setCompanyId] = useState(null);
  const getCompany = async () => {
    try {
      const res = await getOwnCompaniesList();
      const data = res.map(mapCompanyOption);
      setCompanyData(data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getCompany();
  }, []);
  //********Company List End  ********//
  console.log("companySearch", companySearch);

  //********Job Type List Start  ********//
  const [jobTypeData, setJobTypeData] = useState([]);
  const [jobTypeSearch, setJobTypeSearch] = useState("");
  const [jobTypeId, setJobTypeId] = useState(null);
  const getJobType = () => {
    axios
      .get(`Master/GetJobTypesDDL?LangKey=${language}`)
      .then((response) => {
        const res = response.data.responseData;
        const data = res.map((item) => ({
          value: item.id,
          label: item.name,
        }));
        setJobTypeData(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    if (jobTypeSearch) {
      getJobType();
    }
  }, [jobTypeSearch]);
  //********Job Type List End  ********//

  //********Work Level Type List Start  ********//
  const [workTypeData, setWorkTypeData] = useState([]);
  const [WorkTypeSearch, setWorkTypeSearch] = useState("");
  const [workTypeId, setWorkTypeId] = useState(null);
  const getWorkType = () => {
    axios
      .get(`Master/GetWorkLevelTypesDDL?LangKey=${language}`)
      .then((response) => {
        const res = response.data.responseData;
        const data = res.map((item) => ({ value: item.id, label: item.name }));
        setWorkTypeData(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    if (WorkTypeSearch) {
      getWorkType();
    }
  }, [WorkTypeSearch]);
  //********Work Level Type List End  ********//

  //********Work Location Type List Start  ********//
  const [workLocationData, setWorkLocationData] = useState([]);
  const [WorkLocationSearch, setWorkLocationSearch] = useState("");
  const [workLocationId, setWorkLocationId] = useState(null);
  const getWorkLocationType = () => {
    axios
      .get(`Master/GetWorkLocationTypesDDL?LangKey=${language}`)
      .then((response) => {
        const res = response.data.responseData;
        const data = res.map((item) => ({ value: item.id, label: item.name }));
        setWorkLocationData(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    getWorkLocationType();
  }, []);
  //********Work Location Type List End  ********//
  //********Work Location Type List Start  ********//
  const [salaryData, setsalaryData] = useState([]);
  const [salaryDataSearch, setSalaryDataSearch] = useState("");
  const [salaryId, setsalaryId] = useState(null);
  const getsalaryType = () => {
    axios
      .get(`Master/GetSalaryTypesDDL?LangKey=${language}`)
      .then((response) => {
        const res = response.data.responseData;
        const data = res.map((item) => ({
          value: item.jbSlryTypId,
          label: item.name,
        }));
        setsalaryData(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    getsalaryType();
  }, []);

  //********Work Location Type List End  ********//

  //********City List Start  ********//
  const [cityData, setCityData] = useState([]);
  const [cityId, setCityId] = useState(null);
  const [citySearch, setCitySearch] = useState("");
  const getCity = () => {
    axios
      .get(`Master/GetCitiesDDL?search=${citySearch}&LangKey=${language}`)
      .then((response) => {
        const res = response.data.responseData;
        const data = res.map((item) => ({
          value: item.cityId,
          label: item.cityName,
        }));
        setCityData(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    if (citySearch) {
      getCity();
    }
  }, [citySearch]);

  console.log("citySearch", citySearch);

  //********City List End  ********//

  //************************Designation Start  ************************//
  const [value, setValue] = useState(null);
  const [pageD, setPageD] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [typeddesignation, setTypeddesignation] = useState("");
  const [totalPagesDesignation, setTotalPagesDesignation] = useState(0);

  const logValue = debounce((typed) => {
    setTypeddesignation(typed);
  }, 250);

  const [designationData, setDesignationData] = useState([]);
  const [designation, setDesignation] = useState("");
  const [showInputInsteadOfDropdownD, setShowInputInsteadOfDropdownD] = useState(false);

  const addOptions = (nextPage = pageD + 1) => {
    if (!(master.fitid > 0)) {
      setIsLoading(false);
      return;
    }
    setIsLoading(true);
    axios
      .get(
        `Master/GetDesignationDDL?DeviceType=Web&search=${typeddesignation}&Fitid=${master.fitid}&pageNumber=${nextPage
        }&pageSize=100&LangKey=${language}`
      )
      .then((response) => {
        console.log("response=====>", response);
        const data = response?.data?.responseData?.data?.map((item) => ({
          value: item.dsgntnId,
          label: item.name,
        })) || [];
        setPageD(nextPage);
        setIsLoading(false);
        setDesignationData((prevOptions) => {
          const nextOptions = nextPage === 1 ? data : [...prevOptions, ...data];
          return nextOptions.filter(
            (option, index, allOptions) =>
              index === allOptions.findIndex((item) => item.value === option.value)
          );
        });
        setTotalPagesDesignation(response?.data?.paging?.totalPages || 0);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };


  const handleOpen = () => {
    setPageD(0);
    if (designationData.length === 0) {
      addOptions(1);
    }
  };

  const handleChange = (selectedOption) => {
    if (!selectedOption) {
      setValue(null);
      setDesignation("");
      setShowInputInsteadOfDropdownD(false);
      return;
    }

    setValue(selectedOption);
    setDesignation(selectedOption.label || "");
    setPageD(0);

    if (typeof selectedOption.value === "string") {
      setShowInputInsteadOfDropdownD(true);
    } else {
      setShowInputInsteadOfDropdownD(false);
    }
  };

  const handleInputChange = (typed) => {
    logValue(typed);
    if (!typed) {
      setPageD(0);
      setTypeddesignation("");
    }
  };

  const handleMenuScrollToBottom = () => {
    if (pageD < totalPagesDesignation) {
      addOptions(pageD + 1);
    }
  };



  useEffect(() => {
    if (typeddesignation) {
      setPageD(0);
      addOptions(1);
    }
  }, [typeddesignation]);

  //************************ Designation End  ************************//

  const handleSubmit = async () => {
    setDisplay(true);
    const masterPayload = master.jobMasterPayload();
    const companyUid =
      typeof companyId === "object" && companyId !== null
        ? companyId.value
        : companyId;
    const cityValue =
      typeof cityId === "object" && cityId !== null ? cityId.value : cityId;
    const jobTypeValue =
      typeof jobTypeId === "object" && jobTypeId !== null
        ? jobTypeId.value
        : jobTypeId;
    const workTypeValue =
      typeof workTypeId === "object" && workTypeId !== null
        ? workTypeId.value
        : workTypeId;
    const workLocationValue =
      typeof workLocationId === "object" && workLocationId !== null
        ? workLocationId.value
        : workLocationId;
    const salaryValue =
      typeof salaryId === "object" && salaryId !== null
        ? salaryId.value
        : salaryId;
    const body = {
      deviceType: "Web",
      sessionId: sessionId,
      compUid: companyUid,
      locationId: null,
      cityID: cityValue,
      jbTypId: jobTypeValue,
      workLevelType: workTypeValue,
      workLocationType: workLocationValue,
      designationName: masterPayload.designationName || value?.label || designation,
      industryId: masterPayload.industryId,
      skillIds: masterPayload.skillIds,
      skillNames: masterPayload.skillNames,
      salaryTypeId: salaryValue,
      minSalary: minimumSalary,
      maxSalary: maximumSalary,
      currency: null,
      title: jobTitle,
      description: jobDescription,
      hashTags: hashtags,
      sourceTypeId: null,
      receiveApplicantsType: 1,
      jobId: item.jobId,
      langKey: language === "en" ? "" : language,
    };
    console.log('cityId', cityId, jobTypeId, workTypeId, workLocationId, salaryId, minimumSalary, maximumSalary, jobTitle, jobDescription);

    if (
      cityId === null ||
      jobTypeId === null ||
      workTypeId === null ||
      workLocationId === null ||
      jobTitle === "" ||
      jobDescription === ""
    ) {
      setWarningToastMessage("Please fill all fields");
      setShowWarningToast(true);
    } else {
      try {
        const res = await axios.put("/Job/UpdateJob", body);
        console.log('gashgdjdgsa', res.data.message);
        await saveScreeningQuestions(item.jobId);
        setToastMessage(res.data.message);
        setShowToast(true);
        AllJobList(1);

        setTimeout(() => {
          closeModal();
        }, 2000);
      } catch (e) {
        if (e.response && e.response.status === 404) {
          setWarningToastMessage(e.response.data.message);
          setShowWarningToast(true);
        } else {
          setErrorToastMessage(e.response.data.message);
          setShowErrorToast(true);
        }
      }
    }
  };


  useEffect(() => {
    if (jobListData) {
      setCompanyId(jobListData?.compUid);
      setCompanySearch(jobListData?.compName);
      setCityId(jobListData?.cityId);
      setCitySearch(jobListData?.cityName);
      setJobTypeId(jobListData?.jbTypId);
      setJobTypeSearch(jobListData?.jbTypName);
      setWorkTypeId(jobListData?.workLevelType);
      setWorkTypeSearch(jobListData?.workLevelTypeName);
      setWorkLocationId(jobListData?.workLocationType);
      setWorkLocationSearch(jobListData?.workLocationTypeName);
      setDesignation(jobListData?.designationName || "");
      setsalaryId(jobListData?.salaryTypeId);
      setSalaryDataSearch(jobListData?.salaryTypeName);
      // setjobDescription(jobListData?.fullDescription);
      setjobDescription(cleanShortDescription(jobListData.fullDescription));

    }
  }, [jobListData]);
  const [activeStep, setActiveStep] = useState(1);
  const handleNext = () => {
    setActiveStep(activeStep + 1);
  };

  const handlePrev = () => {
    setActiveStep(activeStep - 1);
  };

  return (
    <>
      {showModal && (

        <div
          className="modal fade show postAdd jobCreate modal-lg"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around ">
              <div className="setting-header d-flex justify-content-between align-items-center">
                <h6>{t("Newsfeed.Update Job")}</h6>
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    closeModal(); // If not on step 2, just close the modal normally
                  }
                  } />
              </div>
              <div className="bs-stepper">
                <div className="bs-stepper-content p-0">
                  <div
                    id="logins-part"
                    className={`content ${activeStep === 1 ? "active" : ""}`}
                    role="tabpanel"
                    aria-labelledby="logins-part-trigger"
                  >
                    <Row>
                      <Col md={12}>
                        <Form onSubmit={(e) => e.preventDefault()}>
                          <div className="row p-4 pt-0 settings CreateCompany  p-0">
                            <div className="col-md-6 mt-2">
                              <label htmlFor="about">
                                {t("Newsfeed.Company Name")}
                                {" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>

                              <Select
                                value={companyData.find(
                                  (option) => option.value === (typeof companyId === "object" ? companyId?.value : companyId)
                                )}
                                onChange={(e) => {
                                  setCompanyId(e.value);
                                  master.applyCompanyIndustry(e);
                                }}
                                options={companyData}
                                placeholder= {t("Newsfeed.Search and Select Company Name")}
                                onInputChange={(inputValue) => {
                                  setCompanySearch(inputValue);
                                }}
                                invalid={display && companySearch === ""}
                                styles={customStyles}
                              />
                              {display && !companyId ? (
                                <span className="error_msg_lbl">
                                  {t("Newsfeed.Select Company Name")}
                                  {" "}
                                </span>
                              ) : null}
                            </div>

                            <div className="col-md-6 mt-2">
                              <label htmlFor="industry">
                                {t("User Profile.Industry")}
                                {" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <Select
                                value={master.industry}
                                onChange={master.onIndustryChange}
                                options={master.industryList}
                                placeholder={t("User Profile.Select industry")}
                                styles={customStyles}
                                isClearable
                              />
                              {display && !master.fitid ? (
                                <span className="error_msg_lbl">
                                  {t("User Profile.Please Select industry")}
                                </span>
                              ) : null}
                            </div>

                            <div className="col-md-6 mt-2">
                              <label htmlFor="about">
                                {t("Newsfeed.Designation")}
                                {" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>

                              <CreatableSelect
                                value={master.designation || value}
                                options={master.designationOptions}
                                placeholder={t("modals.Search and Select Designation")}
                                onMenuOpen={master.onDesignationMenuOpen}
                                onChange={(selectedOption) => {
                                  master.setDesignation(selectedOption);
                                  handleChange(selectedOption);
                                }}
                                onMenuScrollToBottom={master.onDesignationMenuScroll}
                                onInputChange={master.onDesignationInputChange}
                                isClearable
                                isDisabled={!master.fitid}
                                isLoading={master.designationLoading}
                                isValidNewOption={(inputValue, _, selectOptions) =>
                                  !!inputValue &&
                                  !selectOptions.some(
                                    (option) =>
                                      option.label.toLowerCase() === inputValue.toLowerCase()
                                  )
                                }
                                onCreateOption={async (inputValue) => {
                                  const option = await master.createDesignation(inputValue);
                                  setDesignation(inputValue);
                                  setValue(option);
                                }}
                                styles={customStyles}
                              />
                              {display && !(master.designation || value) ? (
                                <span className="error_msg_lbl">
                                  {t("SearchJob.Select Designation")}
                                  {" "}
                                </span>
                              ) : null}
                            </div>

                            <div className="col-md-12 mt-2">
                              <label htmlFor="skills">
                                {t("User Profile.Skills")}
                              </label>
                              <CreatableSelect
                                {...creatableSkillSelectDefaults}
                                value={master.skills}
                                options={master.skillOptions}
                                placeholder={t("User Profile.Search and Select Skill")}
                                onMenuOpen={master.onSkillMenuOpen}
                                onChange={(selected) => master.setSkills(selected || [])}
                                onMenuScrollToBottom={master.onSkillMenuScroll}
                                onInputChange={onCreatableInputChange(master.onSkillInputChange)}
                                onCreateOption={master.createSkill}
                                isDisabled={false}
                                isLoading={master.skillLoading}
                                styles={customStyles}
                              />
                              <SkillSuggestChips
                                title={jobTitle}
                                fitid={master.fitid}
                                selected={master.skills}
                                onAdd={(option) => {
                                  const exists = (master.skills || []).some(
                                    (s) => String(s.value) === String(option.value) || s.label === option.label
                                  );
                                  if (!exists) master.setSkills([...(master.skills || []), option]);
                                }}
                              />
                            </div>

                            <div className="col-md-6 mt-2">
                              <label htmlFor="about">
                                 {t("Newsfeed.Job Title")}
                                {" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="text"
                                value={jobTitle}
                                onChange={(e) => setjobTitle(e.target.value)}
                              />
                              {display && !jobTitle ? (
                                <span className="error_msg_lbl">
                                   {t("Newsfeed.Enter Job Title")}
                                  {" "}
                                </span>
                              ) : null}
                            </div>

                            <div className="col-md-6 mt-2">
                              <label htmlFor="about">
                                {t("Newsfeed.City Name")}
                                {" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <Select
                                value={cityData.find((option) => option.value === cityId)}
                                onChange={(selectedOption) =>
                                  setCityId(selectedOption.value)
                                }
                                options={cityData}
                                placeholder= {t("modals.Search and Select City")}
                                onInputChange={(inputValue) => {
                                  setCitySearch(inputValue);
                                }}
                                invalid={display && citySearch === ""}
                                styles={customStyles}
                              />
                              {display && !cityId ? (
                                <span className="error_msg_lbl">
                                  {t("SearchJob.Select City")}
                                  {" "}
                                </span>
                              ) : null}
                            </div>

                            <div className="col-md-6 mt-2">
                              <label htmlFor="about">
                                {t("Newsfeed.Job Type")}
                                 <span style={{ color: "red" }}>*</span>
                              </label>
                              <Select
                                value={jobTypeData.find(
                                  (option) => option.value === jobTypeId
                                )}
                                onChange={(e) => {
                                  setJobTypeId(e.value);
                                }}
                                options={jobTypeData}
                                placeholder= {t("Newsfeed.Search and Select Job Type")}
                                onInputChange={(inputValue) => {
                                  setJobTypeSearch(inputValue);
                                }}
                                invalid={display && jobTypeSearch === ""}
                                styles={customStyles}
                                isSearchable={false}

                              />
                              {display && !jobTypeId ? (
                                <span className="error_msg_lbl">
                                  {t("Newsfeed.Select Job Type")}
                                  {" "}
                                </span>
                              ) : null}
                            </div>

                            <div className="col-md-6 mt-2">
                              <label htmlFor="about">
                                 {t("Newsfeed.Work Level Type")}
                                {" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <Select
                                value={workTypeData.find(
                                  (option) => option.value === workTypeId
                                )}
                                onChange={(e) => {
                                  setWorkTypeId(e.value);
                                }}
                                options={workTypeData}
                                placeholder= {t("Newsfeed.Search and Select Work Level Type")}
                                onInputChange={(inputValue) => {
                                  setWorkTypeSearch(inputValue);
                                }}
                                invalid={display && workTypeId === ""}
                                styles={customStyles}
                                isSearchable={false}

                              />
                              {display && !workTypeId ? (
                                <span className="error_msg_lbl">
                                  {t("Newsfeed.Select Work Level Type")}
                                  {" "}
                                </span>
                              ) : null}
                            </div>

                            <div className="col-md-6 mt-2">
                              <label htmlFor="about">
                                 {t("Newsfeed.Work Location Type")}
                                {" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              {/* <input type='text' /> */}
                              <Select
                                value={workLocationData.find(
                                  (option) => option.value === workLocationId
                                )}
                                onChange={(e) => {
                                  setWorkLocationId(e.value);
                                }}
                                options={workLocationData}
                                placeholder= {t("Newsfeed.Search and Select Work Location Type")}
                                onInputChange={(inputValue) => {
                                  setWorkLocationSearch(inputValue);
                                }}
                                invalid={display && WorkLocationSearch === ""}
                                styles={customStyles}
                                isSearchable={false}

                              />
                              {display && !workLocationId ? (
                                <span className="error_msg_lbl">
                                  {t("Newsfeed.Select Work Location Type")}
                                 {" "}
                                </span>
                              ) : null}
                            </div>
                          </div>
                          <div className="p-4 col-md-12 text-end mt-4">
                            <button
                              type="button"
                              className="mainBtn1"
                              onClick={() => {
                                if (
                                  jobTitle === "" ||
                                  cityId === "" ||
                                  jobTypeId === "" ||
                                  companyId === "" ||
                                  workTypeId === "" ||
                                  workLocationId === ""
                                ) {
                                  setWarningToastMessage(
                                    "Please fill all fields"
                                  );
                                  setDisplay(true);
                                  setShowWarningToast(true);
                                } else {
                                  handleNext();
                                }
                              }}
                              disabled={
                                cityId === null ||
                                jobTypeId === null ||
                                companyId === null ||
                                workTypeId === null ||
                                workLocationId === null ||
                                jobTitle === ""
                              }
                            >
                              {t("Newsfeed.Next")}   
                            </button>
                          </div>
                        </Form>
                      </Col>
                    </Row>
                  </div>
                  <div
                    id="information-part"
                    className={`content ${activeStep === 2 ? "active" : ""}`}
                    role="tabpanel"
                    aria-labelledby="information-part-trigger"
                  >
                    <Row>
                      <Col md={12}>
                        <div className="form-progress-cont d-flex align-items-center px-3 progress-bar-blue">

                        </div>
                        <div className="row p-4 pt-0 settings CreateCompany  p-0">


                          <div className="col-md-12 mt-2">
                            <label htmlFor="about">
                               {t("Newsfeed.Salary Type")} 
                              {" "}
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            <Select
                              value={salaryData.find(
                                (option) => option.value === salaryId
                              )}
                              onChange={(e) => {
                                setsalaryId(e.value);
                              }}
                              options={salaryData}
                              placeholder={t("Newsfeed.Search and Select Salary Type")}
                              onInputChange={(inputValue) => {
                                setSalaryDataSearch(inputValue);
                              }}
                              invalid={display && salaryDataSearch === ""}
                              styles={customStyles}
                                isSearchable={false}

                            />
                            {display && !salaryId ? (
                              <span className="error_msg_lbl">
                                 {t("Newsfeed.Select Salary Type")}  
                              </span>
                            ) : null}
  
                          </div>

                          <div className="col-md-6 mt-2">
                            <label htmlFor="about">{t("Newsfeed.Minimum Salary($)")} </label>
                            <input
                              type="number"
                              value={minimumSalary}
                              onChange={(e) => {
                                setMinimumSalary(e.target.value);
                              }}
                            />
                            {/* {display && !minimumSalary ? (
                              <span className="error_msg_lbl">
                                Enter Minimum Salary{" "}
                              </span>
                            ) : null} */}
                          </div>

                          <div className="col-md-6 mt-2">
                            <label htmlFor="about">{t("Newsfeed.Maximum Salary($)")}
                              {minimumSalary && maximumSalary && parseFloat(minimumSalary) > parseFloat(maximumSalary) && (
                                <span className="text-danger ms-2">{t("Drafts.Max cannot be less than Min")}</span>
                              )}
                            </label>
                            <input
                              type="number"
                              value={maximumSalary}
                              onChange={(e) => setMaximumSalary(e.target.value)}
                            />
                            {/* {display && !maximumSalary ? (
                              <span className="error_msg_lbl">
                                Enter Maximum Salary{" "}
                              </span>
                            ) : null} */}
                          </div>

                          <div className="col-md-12 mt-2">
                            <label htmlFor="about">{t("Newsfeed.Job Description")}
                              <span style={{ color: "red" }}>*</span> </label>
                            {/* <textarea
                              id="about"
                              name="about"
                              rows="4"
                              cols="50"
                              value={jobDescription}
                              onChange={(e) =>
                                setjobDescription(e.target.value)
                              }
                            ></textarea> */}
                            <ReactQuill
                              theme="snow"
                              value={jobDescription}
                              onChange={setjobDescription}
                              id="about"
                              style={{ height: "130px", marginBottom: "40px" }}
                            />
                            {display && !jobDescription ? (
                              <span className="error_msg_lbl">
                                {t("Newsfeed.EnterJob Description")}
                                {" "}
                              </span>
                            ) : null}
                          </div>

                          <div className="col-md-12 mt-3">
                            <label htmlFor="screening-questions">
                              Screening questions
                            </label>
                            {screeningQuestions.map((question, index) => (
                              <div
                                key={`sq-${index}`}
                                className="d-flex align-items-center gap-2 mb-2"
                              >
                                <input
                                  type="text"
                                  className="form-control"
                                  value={question}
                                  placeholder={`Question ${index + 1}`}
                                  onChange={(e) =>
                                    updateScreeningQuestion(
                                      index,
                                      e.target.value
                                    )
                                  }
                                />
                                <button
                                  type="button"
                                  className="btn btn-sm btn-outline-danger"
                                  onClick={() =>
                                    removeScreeningQuestion(index)
                                  }
                                >
                                  Remove
                                </button>
                              </div>
                            ))}
                            {screeningQuestions.length < 5 && (
                              <button
                                type="button"
                                className="btn btn-sm btn-outline-primary mt-1"
                                onClick={addScreeningQuestion}
                              >
                                Add question
                              </button>
                            )}
                          </div>

                          <Col md={12}>
                            <Form onSubmit={(e) => e.preventDefault()}>
                              <div className="row p-4 pt-0 settings CreateCompany">
                                <div className="text-end mt-4 d-flex justify-content-between">
                                  <div className="previousBtnCont d-flex align-items-center">
                                    <ArrowBackIosNewSharpIcon className="material-symbols-sharp" />
                                    <button
                                      type="button"
                                      className="previousBtn"
                                      onClick={handlePrev}
                                    >
                                      {t("Newsfeed.Previous")}
                                    </button>
                                  </div>
                                  <button
                                    type="submit"
                                    className="mainBtn1 jobPosting"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      handleSubmit();
                                    }}
                                  >
                                    {t("Newsfeed.Update")} 
                                  </button>
                                </div>
                              </div>
                            </Form>
                          </Col>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  {/* <div
                    id="information-part"
                    className={`content ${activeStep === 3 ? "active" : ""}`}
                    role="tabpanel"
                    aria-labelledby="information-part-trigger"
                  >

                    <Row>
                      <Col md={12}>
                        <div className="jobdata-content-cont d-flex flex-column p-3 pb-0">
                          <p className="fw-bold">{jobData.description}</p>
                          <p className="fw-bold">{jobData.title}</p>
                          <p>{jobData.compName}</p>
                          <p>({jobData.workLocationTypeName})</p>
                          <p>{jobData.maxSalary}</p>
                        </div>
                      </Col>

                      <Col md={12}>
                        <Form onSubmit={(e) => e.preventDefault()}>
                          <div className="row p-4 pt-0 settings CreateCompany">
                            <div className="text-end mt-4 d-flex justify-content-between">
                              <div className="previousBtnCont d-flex align-items-center">
                                <ArrowBackIosNewSharpIcon className="material-symbols-sharp" />
                                <button
                                  type="button"
                                  className="previousBtn"
                                  onClick={handlePrev}
                                >
                                  Previous
                                </button>
                              </div>
                              <button
                                type="submit"
                                className="mainBtn1 jobPosting"
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleSubmit();
                                }}
                              >
                                Update
                              </button>
                            </div>
                          </div>
                        </Form>
                      </Col>
                    </Row>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <SuccessToast
        show={showToast}
        message={toastMessage}
        onClose={() => setShowToast(false)}
      />

      <WarningToast
        show={showWarningToast}
        message={warningToastMessage}
        onClose={() => setShowWarningToast(false)}
      />

      <ErrorToast
        show={showErrorToast}
        message={ErrorToastMessage}
        onClose={() => setShowErrorToast(false)}
      />
    </>
  );
};

export default UpdateJob;
